import { MessagePathNode } from "@/shared/domain/topics";

import { TopicData } from "./schema";

/**
 * Whether two TopicData entries reference the same renderable signal.
 *
 * The server-assigned messagePath.id alone is not a sufficient identity: an
 * array field has a single message-path record, so every index of the array
 * (e.g. `axes[1]` vs `axes[2]`) shares one id and differs only in its slice
 * parts. Parts are compared via their string form, which also normalizes a
 * full-array slice's `end` across its persisted (`null`) and in-memory
 * (`Infinity`) representations.
 */
export function isSameDataSource(a: TopicData, b: TopicData): boolean {
  return (
    a.messagePath.id === b.messagePath.id &&
    MessagePathNode.partsToString(a.messagePath.parts) ===
      MessagePathNode.partsToString(b.messagePath.parts)
  );
}

export function idForClip(): string {
  return crypto.randomUUID();
}

export function idForSeries(): string {
  return crypto.randomUUID();
}

export function idForMap(data: TopicData[]): string {
  if (data.length > 0) {
    // A map path's data is a latitude/longitude pair for one file. Build the
    // id from the server-assigned message-path ids (unique per file) so two
    // paths sharing a topic name across different files get distinct ids.
    return data
      .map((d) => d.messagePath.id)
      .sort()
      .join("-");
  } else {
    return "Map";
  }
}
